import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'lead-coaching-fitness',
    title: 'Lead qualificado — Coaching fitness',
    description: 'Qualifique seus leads com perguntas estratégicas antes de oferecer seu programa de coaching fitness.',
    indicatedFor: 'Personal trainers',
    stepsCount: 1,
    questionsSummary: ['Nome e contato', 'Nível de comprometimento', 'Investimento anterior', 'Maior desafio'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Quero transformar meu corpo',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Me conta um pouco sobre você',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar candidatura',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: 'Seu nome completo',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'email',
                        label: 'Seu melhor e-mail',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'phone',
                        label: 'WhatsApp para contato',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'text',
                        label: 'Qual é o seu maior desafio hoje em relação ao seu corpo e saúde?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 5,
                        type: 'yes_no_maybe',
                        label: 'Você já investiu em algum programa de treinamento ou acompanhamento antes?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 6,
                        type: 'scale',
                        label: 'De 1 a 5, o quanto você está comprometido em mudar agora?',
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: 'Ainda estou pensando',
                            maxLabel: 'Totalmente pronto',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                ],
            },
        ],
        actions: [],
    },
};
